import React from "react";

export default ({record}) => {
  return <span>Page {record.email ? `"${record.email}"` : ''}</span>;
}
